// extracted by mini-css-extract-plugin
export default {"drawerSection":"ResourceRules_drawerSection__blW2C"};